<script setup lang="ts">
  const showProgress = ref(false)

  const fallbackHandle = () => {
    showProgress.value = true
  }

  const resolveHandle = () => {
    showProgress.value = false
  }


  defineExpose({
    fallbackHandle,
    resolveHandle,
  })
</script>

<template>
  <v-container
    v-if="showProgress"
    cols="12"
    lg="8"
    md="10"
    xl="4"
    xxl="3"
  >
    <v-skeleton-loader type="card" />
    <v-skeleton-loader type="card" />
    <v-skeleton-loader type="card" />
  </v-container>
</template>

<style scoped lang="sass">

</style>
